import React from 'react';
import { Resource } from 'react-admin';
import SGXPermissions from "../libs/sgx/auth/SGXPermissions";

import {ROOT, ADMINISTRADOR, AUDITOR} from './roles';
import users from "./users";
import passwordReset from "./password-reset";
import reglaEtiqueta from "./regla-etiqueta";
import configuracionesGenerales from "./configuraciones-generales";
import grupoRegla from "./grupo-regla";
import tope from "./tope";
import prestaciones from "./prestaciones";
import tiposRegla from "./tipos-regla";
import codigoRechazo from "./codigo-rechazo";
import profesionales from "./profesionales";
import grupoValidaciones from "./grupo-validaciones";
import prestacionGrupoRegla from "./prestacion-grupo-regla";
import reglaTipoTransaccion from "./regla-tipo-transaccion";
import tiposTransaccion from "./tipos-transaccion";
import historicoValidaciones from "./historico-validaciones";
import prestacionGrupoValidaciones from "./prestacion-grupo-validaciones";
import excepciones from "./excepciones";
import estadoValidaciones from "./estado-validaciones";
import etiquetas from "./etiquetas";
import estadoRegla from "./estado-regla";
import regla from "./regla";

const resourcesAdminRoot = (permissions: SGXPermissions) => [
    <Resource name="users" {...users} />,
    <Resource name="password-reset" {...passwordReset} />,
    <Resource name="roles" />,
    <Resource name="regla" {...regla} />,
    <Resource name="grupo-regla" {...grupoRegla} />,
    <Resource name="grupo-validaciones" {...grupoValidaciones} />,
    <Resource name="codigo-rechazo" {...codigoRechazo} />,
    <Resource name="excepciones" {...excepciones} />,
    <Resource name="configuraciones-generales" {...configuracionesGenerales} />,
    <Resource name="tope" {...tope} />,
    <Resource name="prestacion-grupo-regla" {...prestacionGrupoRegla} />,
    <Resource name="prestacion-grupo-validaciones" {...prestacionGrupoValidaciones} />,
    <Resource name="regla-tipo-transaccion" {...reglaTipoTransaccion} />,
    <Resource name="prestaciones" {...prestaciones} />,
    <Resource name="historico-validaciones" {...historicoValidaciones(permissions)} />,
    <Resource name="tipos-transaccion" {...tiposTransaccion} />,
    <Resource name="tipos-regla" {...tiposRegla} />,
    <Resource name="estado-regla" {...estadoRegla} />,
    <Resource name="estado-validaciones" {...estadoValidaciones} />,
    <Resource name="regla-etiqueta" {...reglaEtiqueta} />,
    <Resource name="etiquetas" {...etiquetas} />,
    <Resource name="profesionales" {...profesionales} />,

];

const resourcesAdministrador = (permissions: SGXPermissions) => [
    <Resource name="roles" />,
    <Resource name="regla" {...regla} />,
    <Resource name="grupo-regla" {...grupoRegla} />,
    <Resource name="grupo-validaciones" {...grupoValidaciones} />,
    <Resource name="codigo-rechazo" {...codigoRechazo} />,
    <Resource name="excepciones" {...excepciones} />,
    <Resource name="configuraciones-generales" {...configuracionesGenerales} />,
    <Resource name="tope" {...tope} />,
    <Resource name="prestacion-grupo-regla" {...prestacionGrupoRegla} />,
    <Resource name="prestacion-grupo-validaciones" {...prestacionGrupoValidaciones} />,
    <Resource name="regla-tipo-transaccion" {...reglaTipoTransaccion} />,
    <Resource name="prestaciones" {...prestaciones} />,
    <Resource name="historico-validaciones" {...historicoValidaciones(permissions)} />,
    <Resource name="tipos-transaccion" {...tiposTransaccion} />,
    <Resource name="tipos-regla" {...tiposRegla} />,
    <Resource name="estado-regla" {...estadoRegla} />,
    <Resource name="estado-validaciones" {...estadoValidaciones} />,
    <Resource name="regla-etiqueta" {...reglaEtiqueta} />,
    <Resource name="etiquetas" {...etiquetas} />,

];

const resourcesAuditor = (permissions: SGXPermissions) => [
    <Resource name="prestaciones" {...prestaciones} />,
    <Resource name="historico-validaciones" {...historicoValidaciones(permissions)} />,
    <Resource name="tipos-transaccion" {...tiposTransaccion} />,
    <Resource name="tipos-regla" {...tiposRegla} />,
    <Resource name="estado-regla" {...estadoRegla} />,
    <Resource name="estado-validaciones" {...estadoValidaciones} />
];

const resourcesRecetas = (permissions: SGXPermissions) => [
    <Resource name="historico-validaciones" {...historicoValidaciones(permissions)} />,
];

const resourcesFor = (permissions: SGXPermissions) => {
    return permissions.hasAnyAssignment(ROOT) ?
        [resourcesAdminRoot(permissions)] :
        permissions.hasAnyAssignment(ADMINISTRADOR) ?
            [resourcesAdministrador(permissions)] :
            permissions.hasAnyAssignment(AUDITOR) ?
                [resourcesAuditor(permissions)]:
                [resourcesRecetas(permissions)]
}



const resources = (permissions: SGXPermissions) => [
    ...resourcesFor(permissions),
];

export default resources;